const router = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login-index.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
]
export default router
